









































import {
  createComponent,
  provide,
  inject,
  onMounted,
  computed,
  reactive,
  ref,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import MemberKey from "@/components/member-key";
import logoSvg from "@/assets/svg/logo.svg";
import { ScalingSquaresSpinner } from "epic-spinners";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const globalStore = context.root.$store;

    const openBlank = (rooteName: string) => {
      let resolveRoute = context.root.$router.resolve({ name: rooteName });
      window.open(resolveRoute.href, "_blank");
    };

    onMounted(async () => {
      globalStore.auth.clearResponse();
      globalStore.auth.clearLoginParams();
    });

    return {
      openBlank
    };
  },
  components: {
    logoSvg,
    ScalingSquaresSpinner
  }
});
